export default "__VITE_ASSET__4MN3vGku__"